import { marked } from "marked";
import DOMPurify from "dompurify";

export function renderMarkdown(content: string): string {
  const raw = marked(content) as string;
  return DOMPurify.sanitize(raw);
}
